import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingComponent } from '../billing/billing.component';
import { BillingRoutingModule } from './billing-routing.module';
import { MaterialModule } from '../material.module';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ShortRegistoreComponent } from './short-registore/short-registore.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from "@angular/material/form-field";
import {SharedModule} from '../shared/shared.module';
import { VisitComponent } from './visit/visit.component';
import { PrintInvoiceComponent } from './print-invoice/print-invoice.component';
import { ReciptComponent } from './recipt/recipt.component';
import { BillingSearchComponent } from './billing-search/billing-search.component';
import { RefundComponent } from './refund/refund.component';
import { AdvanceRecieptComponent } from './advance-reciept/advance-reciept.component';
import { AddPackageComponent } from './add-package/add-package.component';
import { CorporateDetailComponent } from './corporate-detail/corporate-detail.component';
import { CourierDetailsComponent } from './courier-details/courier-details.component';
import { BillRefundComponent } from './bill-refund/bill-refund.component';
import { BillRecoveryManagerComponent } from './bill-recovery-manager/bill-recovery-manager.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { ExcelRecoveryManagerComponent } from './excel-recovery-manager/excel-recovery-manager.component';
import { RecoveryRegisterReportComponent } from './recovery-register-report/recovery-register-report.component';
import { EmailToPartyComponent } from './email-to-party/email-to-party.component';
import { EmailIpdFilesComponent } from './email-to-party/email-ipd-files/email-ipd-files.component';
import { PatientFilesComponent } from './email-to-party/patient-files/patient-files.component';
import { ReferredByComponent } from './referred-by/referred-by.component';

import { NgxBarcodeModule } from 'ngx-barcode';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FilterPartyTPAPipe } from './filter-PartyTPA.pipe';
import { SearchAllColumnPipe } from './search.column';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  declarations: [
    BillingComponent,
    ShortRegistoreComponent,
    
    VisitComponent,
    PrintInvoiceComponent,
    ReciptComponent,
    BillingSearchComponent,
    RefundComponent,
    AdvanceRecieptComponent,
    AddPackageComponent,
    CorporateDetailComponent,
    CourierDetailsComponent,
    BillRefundComponent,
    BillRecoveryManagerComponent,
    ExcelRecoveryManagerComponent,
    RecoveryRegisterReportComponent,
    EmailToPartyComponent,
    EmailIpdFilesComponent,
    PatientFilesComponent,
    ReferredByComponent,
    FilterPartyTPAPipe,
    SearchAllColumnPipe,
  ],
  imports: [
    CommonModule,
    BillingRoutingModule,
    MaterialModule,
   FormsModule,
   MatInputModule,
   MatFormFieldModule,
   SharedModule,ReactiveFormsModule,
   MatAutocompleteModule,
   NgxBarcodeModule,
   Ng2SearchPipeModule,
   ScrollingModule
  ],
  exports:[
    FormsModule,
    ReactiveFormsModule,
    CorporateDetailComponent
  ],
  providers: [
      
    {provide: MatDialogRef, useValue: {}}
 ]
})
export class BillingModule { }
